import React from 'react';
import { Routes, Route, Outlet, useParams } from "react-router-dom";

import { AppContext, useStore } from 'context/AppContext';
import PrivateRoute from 'components/Common/PrivateRoute';
import Heading from 'components/Heading';
import Campaign from 'containers/Campaign';
import Task from 'containers/Task';
import Home from 'containers/Home';
import Profile from 'containers/Profile';
import SocialConnect from 'components/Login/SocialConnect'; // You'll need to create this component
import ScrollToTop from 'components/ScrollToTop';

import './utils/i18n';

// Component to handle profile with userId parameter
const ProfileWithUserId: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  console.log('ProfileWithUserId - userId from URL:', userId);
  return <Profile userId={userId} />;
};

const App: React.FC = () => {
  const store = useStore();

  return (
    <AppContext.Provider value={store}>
      <ScrollToTop />
      <Heading />

      <Routes>
        <Route path="/" element={<PrivateRoute />}>
          {/* Own profile route */}
          <Route path="my-profile">
            <Route index element={<Profile />} />
          </Route>

          {/* Other user's profile route */}
          <Route path="profile/:userId" element={<ProfileWithUserId />} />
        </Route>

        <Route path="/" element={<Outlet />}>
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/task" element={<Task />} />
          {/* Social connect callback route */}
          <Route path="/social-connect" element={<SocialConnect />} />
          <Route index element={<Home />} />
        </Route>

      </Routes>
    </AppContext.Provider>
  );
};

export default App;